import React from "react";
import { Box, Text, type TextProps } from "@chakra-ui/react";
import { type FormProps } from "components/hubspot";
import { DemoForm } from "./demo-form";

type DemoFormWithContainerPRops = {
  /**
   * Title displayed above the form.
   * @default "Book a demo with a product expert"
   */
  title?: string;
  /**
   * The HTML element to render the title as.
   * @default "h2"
   */
  titleAs?: TextProps["as"];
  /**
   * The font size of the title.
   * @default "brand.lg"
   */
  titleFontSize?: TextProps["fontSize"];
  /**
   * Chili Piper router name.
   * @default "inbound-router"
   */
  chiliPiperRouterName?: string;
  /** Callback function when the form is submitted. */
  onSubmit?: () => void;
} & Pick<FormProps, "enableAutoComplete">;

export function DemoFormWithContainer({
  title = "Book a demo with a product expert",
  titleAs = "h2",
  titleFontSize = "brand.lg",
  ...props
}: DemoFormWithContainerPRops) {
  return (
    <Box
      w="100%"
      maxW="lg"
      flexGrow="1"
      p="bigger"
      borderRadius="base"
      bg="brand.background.light"
      filter="drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.08))"
    >
      <Text as={titleAs} textStyle="headline2" fontSize={titleFontSize} mb="small">
        {title}
      </Text>
      <DemoForm {...props} />
    </Box>
  );
}
